import { useContext } from "react";
import { IdentityVerificationContext } from "src/apps/providers/IdentityVerificationProvider";

export const useIdentityVerification = () => {
  return useContext(IdentityVerificationContext);
};
